import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { FIREBASE_CONFIG } from "./app.environment.config";
import { IonicStorageModule } from '@ionic/storage';
//import { HttpClient, HttpHandler } from '@angular/common/http';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';
import { CoverPage } from '../pages/cover/cover';
import { ChaptersPage } from "../pages/chapters/chapters";
import { CommentPage } from "../pages/comment/comment";
import { PresignupPage } from "../pages/presignup/presignup";
import { LoginPage } from "../pages/login/login";
import { RegisterPage } from '../pages/register/register';
import { ProfilePage } from '../pages/profile/profile';
import { StoryPage } from '../pages/story/story';
import { AdsPage } from "../pages/ads/ads";

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Camera } from '@ionic-native/camera';
import { FileTransfer } from '@ionic-native/file-transfer';
import { File } from '@ionic-native/file';

import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { Device } from '@ionic-native/device';

import { StoryProvider } from '../providers/story/story';
import { StorageProvider } from '../providers/storage/storage';
import { UserProvider } from '../providers/user/user';
import { AuthDataProvider } from '../providers/auth-data/auth-data';
import { UserService } from '../services/user.service';
// import { FcmProvider } from '../providers/fcm/fcm';
// import { FCM } from '@ionic-native/fcm';

// IN APP PURCHASE
import { InAppPurchase } from '@ionic-native/in-app-purchase';


@NgModule({
  declarations: [
    MyApp,
    HomePage,
    ListPage,
    CoverPage,
    ChaptersPage,
    CommentPage,
    PresignupPage,
    LoginPage,
    RegisterPage,
    ProfilePage,
    StoryPage,
    AdsPage
  ],
  imports: [
    BrowserModule,
    // IonicModule.forRoot(MyApp),

    IonicModule.forRoot(MyApp, {}, {
      links: [
        { component: HomePage, name: 'HomePage', segment: 'home' },
        { component: CoverPage, name: 'CoverPage', segment: 'home/portada/:historyID' },
        { component: ChaptersPage, name: 'ChaptersPage', segment: 'home/portada/capitulos' },
        { component: CommentPage, name: 'CommentPage', segment: 'home/portada/comentarios' },
        { component: PresignupPage, name: 'PresignupPage', segment: 'PresignupPage' },
        { component: LoginPage, name: 'LoginPage', segment: 'home/login' },
        { component: RegisterPage, name: 'RegisterPage', segment: 'home/login/registro' },
        { component: StoryPage, name: 'StoryPage', segment: 'home/portada/historia/:historyID' },
        { component: ProfilePage, name: 'ProfilePage', segment: 'home/perfil' }
      ]
    }),

    IonicStorageModule.forRoot(),
    AngularFireModule.initializeApp(FIREBASE_CONFIG),
    AngularFirestoreModule,
    AngularFireAuthModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    ListPage,
    CoverPage,
    ChaptersPage,
    CommentPage,
    PresignupPage,
    LoginPage,
    RegisterPage,
    ProfilePage,
    StoryPage,
    AdsPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    Device,
    StoryProvider,
    StorageProvider,
    UserProvider,
    AuthDataProvider,
    UserService,
    Camera,
    InAppPurchase,
    FileTransfer,
    File,
    // FcmProvider,
    // FCM
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts